import { connect } from 'react-redux';
import { modalActions } from '../../reducers/modal.reducer';
import Step3Video from './Step3Video.react';
var Step3 = function Step3() {
  return /*#__PURE__*/React.createElement("div", {
    className: "ht-step-3"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/step3/Step-3.png",
    className: "ht-step-3__3"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/step3/Step-3-RO.png",
    className: "ht-step-3__ro3"
  }), /*#__PURE__*/React.createElement(Step3Video, null), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/step3/step3-wash-rinse-recycle.png",
    className: "ht-step-3__header"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/hydro-tip/step3/blurb.png",
    className: "ht-step-3__blurb"
  }));
};
var mdtp = {
  showModalAction: modalActions.show
};
export default connect(null, mdtp)(Step3);